import TranslationsConfigType from './translationType';

const nnTranslations: TranslationsConfigType = {
    modal: {
        header: 'Bruk av informasjonskapslar (Cookies)',
        subHeader:
            'Me bruker informasjonskapslar (cookies) på nettsidene til banken. Dette er små tekstfiler som blir lagra i nettlesaren din. Desse blir brukte for fleire formål, som å sørgja for at nettsidene fungerer, tryggleik, huske innstillingar og val, og dessutan å måla korleis annonsar fungerer. Nokon er nødvendige for grunnleggjande funksjonar, medan andre blir berre brukte om du gir samtykke. Du kan når som helst endra eller trekkja tilbake samtykket ditt. Les meir i personvernerklæringa vår.',
        acceptAll: 'Godta alle',
        onlyNecessary: 'Kun nødvendige',
    },
    success: {
        header: 'Lagra',
        firstTimeSaveDescription: 'Valane dine vart lagra',
        description: 'Endringene dine vart lagra',
        timeout: 1000,
    },
    cookies: {
        technical: {
            header: 'Strengt nødvendige cookies',
            description:
                'Desse informasjonskapslane er nødvendige for at nettsida skal fungera som ho skal, til dømes for tryggleik og grunnleggjande funksjonar. Dei kan ikkje deaktiverast.',
            cookieName: 'eika_consent_set',
            isDisabled: true,
        },
        marketing: {
            header: 'Marknadsføring',
            description:
                'Me bruker dine data for å måla kor godt kampanjane våre fungerer. Dette hjelper oss å forstå kva annonsar som gir resultat, slik at me kan forbetra marknadsføringa vår. Me bruker ikkje dataen til å visa deg personleg tilpassa annonsar eller til retargeting.',
            cookieName: 'eika_consent_marketing',
        },
    },
};

export default nnTranslations;
